/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Search({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#Search_svg__a)"><path fill="currentColor" fillRule="evenodd" d="M7 .9a6.1 6.1 0 1 0 3.868 10.817l3.208 3.207a.6.6 0 1 0 .848-.848l-3.207-3.208A6.1 6.1 0 0 0 7 .9ZM2.1 7a4.9 4.9 0 1 1 9.8 0 4.9 4.9 0 0 1-9.8 0Z" clipRule="evenodd" /></g><defs><clipPath id="Search_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;